import { FormatR2Duration, FormatTitle } from "../Formatting";
import { ITrack } from "./MapData";

interface Props {
    subTracks: ITrack[]
}
export function TrackGroupBody(prop: Props) {
    return <>
        {
            prop.subTracks.map(track => {
                return (
                    <tr key={`${track.isrc}unq`}>
                        <td colSpan={1} />
                        <td className={"word-break full-width"} colSpan={4}>
                            <span className={"spacer"}>{track.number}</span>
                            <span>{FormatTitle(track.title, track.versionTitle)}</span>
                        </td>
                        <td className={"numeric"}>{FormatR2Duration(track.duration)}</td>
                        <td className={"numeric"} colSpan={3}>{track.isrc}</td>
                    </tr>
                );
            })
        }
    </>;
}
